import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Branch } from '../control-tables/branch-entity';


export class Warehouse extends BaseEntity {

    warehouseCode           : string;
    name                    : string;
    branch                  : Branch;
   
    globalVolume            : number;
    globalWeight            : number;

    isManaged               : boolean;
    useWarehousePacking     : boolean;
    ongoingInventory        : boolean;


  constructor() {
    super();

  }
}
